import React, { Component } from 'react'
import Projectdetail from './Projectdetail'
import Imagerow from './components/Imagerow'
import Updates from './components/Projupdates'

export class Arthur extends Component {

  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/herobg-proj-detail-cash.jpg"
          heading={
            <>
              The Practice of Arthur E. Cash

              <p>Redesigned in process version</p>
            </>
          }
          content={[
            <>
              <p>
              This a redesign in progress of The Practice of Arthur Cash. To give it a more modern look and feel. This version is a more of a cleaner, more minimal look than the current look that is live now.
              </p>
            </>
          ]}
          website="http://www.mlmontheweb.com/projects/thepracticeredesign-v2/"
          github=""
          techs={[
            <>
              <li>Html</li>
              <li>CSS</li>
              <li>JavaScript</li>
            </>
          ]}
          updates={
            [
              <>
                <h2>Recent Updates</h2>

                <p>
                  This is still a work in progress, but this is the direction the redesign
                  of this site is going to. 
                </p>

                <div className="row">

                  <Updates 
                      images="assets/img/screenshots/lrg/"
                  />

                </div>
              </>
            ]
          }
          images={[
            <>
              <div className="row">
                <Imagerow images="assets/img/screenshots/lrg/c0b3faab-48dc-43dd-82f3-7bbb2eea578b.jpg" />

                <Imagerow images="assets/img/screenshots/lrg/7ba675c7-185c-422e-a5ac-0df7517f6a11.jpg" />

                <Imagerow images="assets/img/screenshots/lrg/ab49cc68-1f64-4048-92c5-94b87360c527.jpg" />

                <Imagerow images="assets/img/screenshots/lrg/83ec38a1-0844-40a6-a701-041c4437c7cb.jpg" />

                <Imagerow images="assets/img/screenshots/lrg/463eb5d2-c6fb-4f14-b06d-edeb5465755d.jpg" />

              </div>
            </>
          ]}
        />
      </React.Fragment>
    );
  }
}

export default Arthur
